import React from "react";

import { FullWidthMediaBlock as Value } from "@reactivated";

import { MediaChooserBlock } from "../MediaChooserBlock";

import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const FullWidthMediaBlock = ({ value: { media } }: Props) => {
    if (!media || media.length === 0) return <></>;

    return (
        <MediaChooserBlock
            value={media}
            wrapperAttrs={{ className: styles.wrapper }}
            mediaAttrs={{ className: styles.media }}
        />
    );
};
